/**
*
* MobileTeacherHeader
*
*/

import React, { memo, useState, useRef, useEffect, useCallback, useMemo } from 'react';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Button, List, Empty, Drawer } from 'antd';
import { NavBar } from 'antd-mobile';

// components
import TCFModal from 'components/TCFModal';

import history from 'utils/history';

// contexts
import { withTheme } from 'engine/Contexts/Theme.context';
import {
  withUser,
  useGetUserSchools,
  // useChangeChildByID,
  useGetLocalUser,
  useGetLocalActiveSchool
} from 'engine/Contexts/User.context';

import { useAuthRole } from 'utils/hooks';

function ModalOnSaveChanges({
  // default props
  placement,
  message,
  title,
  okText,
  cancelText,
  closable,
  // actions
  onCancel,
  onConfirm,
  // contexts
  theme,
  // default props
  children,
  className,
}) {

  const containerRef = useRef(null);

  const childClassNames = classNames(
    'tcf-odal-on-save-changes',
    className,
  );

  useEffect(() => {
    return () => {

    }
  }, []);

  const cancelHandler = useCallback(() => {
    !!theme?.isOpenModalOnSaveChanges && (
      theme?.useAdd({
        isOpenModalOnSaveChanges: false,
        canceledModalOnSaveChanges: true,
        savedModalOnSaveChanges: false,
        hasValueModalOnSaveChanges: false,
      }),
      !!onCancel && onCancel()
    )
  }, [theme?.isOpenModalOnSaveChanges, theme?.hasValueModalOnSaveChanges, onCancel]);
  const saveHandler = useCallback(() => {
    !!theme?.isOpenModalOnSaveChanges && !!theme?.hasValueModalOnSaveChanges && (
      theme?.useAdd({
        isOpenModalOnSaveChanges: false,
        hasValueModalOnSaveChanges: false,
        canceledModalOnSaveChanges: false,
        savedModalOnSaveChanges: true,
      }),
      !!onConfirm && onConfirm()
    )
  }, [theme?.isOpenModalOnSaveChanges, theme?.hasValueModalOnSaveChanges.onConfirm]);
  const openHandler = useCallback(() => {
    !!theme?.isOpenModalOnSaveChanges && !!theme?.hasValueModalOnSaveChanges && (
      theme?.useAdd({
        isOpenModalOnSaveChanges: true,
        hasValueModalOnSaveChanges: true,
        canceledModalOnSaveChanges: false,
        savedModalOnSaveChanges: false,
      }),
      !!onConfirm && onConfirm()
    )
  }, [theme?.isOpenModalOnSaveChanges, theme?.hasValueModalOnSaveChanges.onConfirm]);

  return (
    <TCFModal
      open={theme?.isOpenModalOnSaveChanges}
      setOpen={state => openHandler(state)}
      title={title}
      onCancel={cancelHandler}
      onOk={saveHandler}
      cancelName={cancelText}
      submitName={okText}
      closable={closable}
      wrapClassName={childClassNames}
    >
      {message || children}
    </TCFModal>
  );
}

ModalOnSaveChanges.defaultProps = {
  visibility: false,
  placement: 'top',
  title: 'Voulez-vous enregistrer les modifications?',
  message: '',
  okText: 'Oui',
  cancelText: 'Non',
  closable: false
};

export default withTheme(ModalOnSaveChanges);
